"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Prefixes_1 = __importDefault(require("../../shared/models/Prefixes"));
class Core {
    // company permissions
    static Organization_View = 'org'; // View organization
    static Organization_Add = 'org.add';
    static Organization_Edit = 'org.edt'; // Edit organization
    static Organization_Status = 'org.sta';
    static Organization_Delete = 'org.del';
    // user permissions
    static User_View = 'usr'; // View user(s)
    static User_Add = 'usr.add'; // Add user
    static User_Edit = 'usr.edt'; // Edit user
    static User_Status = 'usr.sta'; // Update User Status
    static User_Org_Delete = 'usr.orgUsr.del'; // Remove org access
    static User_Delete = 'usr.del'; // Delete user
    // role permissions
    static Role_View = 'rol'; // View role(s)
    static Role_Add = 'rol.add'; // Add role
    static Role_Edit = 'rol.edt'; // Edit role
    static Role_Delete = 'rol.del'; // Delete role
    // marketing permissions
    static Marketing_Edit = 'mkt.edt'; // Edit marketing blurb
    //user's risk permissions
    static User_Risk_View = 'usr.risk'; // View user(s)
    static User_Risk_Edit = 'usr.risk.edt'; // Edit user
    // Platform Data Import
    static Platform_Data_Import = 'pdi'; // Import data into the platform
    // client registration permissions
    static ClientRegistration_View = 'cr';
    static ClientRegistration_Add = 'cr.add';
    static ClientRegistration_Edit = 'cr.edt';
    static ClientRegistration_Delete = 'cr.del';
    // support chat permissions
    static SupportChat_View = 'sup.chat';
    static SupportPortal_View = 'sup.port';
    // fullfillment marketplace permissions
    static FulfillmentMarketplace_Admin = 'fm.adm';
    static FulfillmentMarketplace_View = 'fm.view';
    // billing permissions
    static Billing_Admin = 'bl.adm';
    static Billing_View = 'bl.view';
    // connection permissions
    static Connection_Admin = 'cn.adm';
    static Connection_View = 'cn.view';
    // login content permisisons
    static Settings_View = 'set.view';
    static Settings_Edit = 'set.edt';
    // alerts permissions
    static Essentials_Admin = 'essentials.admin';
    static Essentials_View = 'essentials.view';
    // temporary analytics workspace permissions
    static Analytics_Workspace_Admin = 'an.wrk.admin';
    static Analytics_Workspace_Edit = 'an.wrk.edit';
    static Analytics_Workspace_View = 'an.wrk.view';
}
class CorePermissions {
    // administrative permissions
    static Admin_Organization_Add = Prefixes_1.default.AdminScope + Core.Organization_Add; // Add Other Orgs
    static Admin_Organization_Status = Prefixes_1.default.AdminScope + Core.Organization_Status; // Edit Status of Other Orgs
    static Admin_Organization_Delete = Prefixes_1.default.AdminScope + Core.Organization_Delete; // Delete Other Orgs
    static Admin_Marketing_Edit = Prefixes_1.default.AdminScope + Core.Marketing_Edit; // Edit Login Page Marketing Content
    static Admin_User_Delete = Prefixes_1.default.AdminScope + Core.User_Delete; // Delete user
    static Admin_Settings_View = Prefixes_1.default.AdminScope + Core.Settings_View; // View Settings
    static Admin_Settings_Edit = Prefixes_1.default.AdminScope + Core.Settings_Edit; // Edit Settings
    // Base permissions
    //-----------------
    static Base_Organization_View = Prefixes_1.default.BaseScope + Core.Organization_View; // View organization
    static Base_Organization_Edit = Prefixes_1.default.BaseScope + Core.Organization_Edit; // Edit organization
    // user permissions
    static Base_User_View = Prefixes_1.default.BaseScope + Core.User_View; // View user(s)
    static Base_User_Add = Prefixes_1.default.BaseScope + Core.User_Add; // Add user
    static Base_User_Edit = Prefixes_1.default.BaseScope + Core.User_Edit; // Edit user
    static Base_User_Status = Prefixes_1.default.BaseScope + Core.User_Status; // Update User Status
    static Base_User_Org_Delete = Prefixes_1.default.BaseScope + Core.User_Org_Delete; // Remove org access
    static Base_User_Delete = Prefixes_1.default.BaseScope + Core.User_Delete; // Delete user
    // role permissions
    static Base_Role_View = Prefixes_1.default.BaseScope + Core.Role_View; // View role(s)
    static Base_Role_Add = Prefixes_1.default.BaseScope + Core.Role_Add; // Add role
    static Base_Role_Edit = Prefixes_1.default.BaseScope + Core.Role_Edit; // Edit role
    static Base_Role_Delete = Prefixes_1.default.BaseScope + Core.Role_Delete; // Delete role
    // user's risk permissions
    static Base_User_Risk_View = Prefixes_1.default.BaseScope + Core.User_Risk_View; // View Users' risk
    static Base_User_Risk_Edit = Prefixes_1.default.BaseScope + Core.User_Risk_Edit; // Edit Users' risk
    // Platform Data Import
    static Base_Platform_Data_Import = Prefixes_1.default.BaseScope + Core.Platform_Data_Import; // Import data into the platform
    static Base_ClientRegistration_View = Prefixes_1.default.BaseScope + Core.ClientRegistration_View;
    static Base_ClientRegistration_Add = Prefixes_1.default.BaseScope + Core.ClientRegistration_Add;
    static Base_ClientRegistration_Edit = Prefixes_1.default.BaseScope + Core.ClientRegistration_Edit;
    static Base_ClientRegistration_Delete = Prefixes_1.default.BaseScope + Core.ClientRegistration_Delete;
    static Base_SupportChat_View = Prefixes_1.default.BaseScope + Core.SupportChat_View;
    static Base_SupportPortal_View = Prefixes_1.default.BaseScope + Core.SupportPortal_View;
    static Base_FM_Admin = Prefixes_1.default.BaseScope + Core.FulfillmentMarketplace_Admin; // Access all fm resources
    static Base_FM_View = Prefixes_1.default.BaseScope + Core.FulfillmentMarketplace_View; // View all fm resources
    static Base_Billing_Admin = Prefixes_1.default.BaseScope + Core.Billing_Admin; // Access all billing resources
    static Base_Billing_View = Prefixes_1.default.BaseScope + Core.Billing_View; // View all billing resources
    // Connection permissions
    static Base_Connection_View = Prefixes_1.default.BaseScope + Core.Connection_View;
    static Base_Connection_Admin = Prefixes_1.default.BaseScope + Core.Connection_Admin;
    static Base_Essentials_View = Prefixes_1.default.BaseScope + Core.Essentials_View;
    static Base_Essentials_Admin = Prefixes_1.default.BaseScope + Core.Essentials_Admin;
    static Base_Analytics_Workspace_Admin = Prefixes_1.default.BaseScope + Core.Analytics_Workspace_Admin;
    static Base_Analytics_Workspace_Edit = Prefixes_1.default.BaseScope + Core.Analytics_Workspace_Edit;
    static Base_Analytics_Workspace_View = Prefixes_1.default.BaseScope + Core.Analytics_Workspace_View;
    // cross org permissions
    //----------------------
    // TODO:  Remove GAdmin_* permissions after fixing the referencing packages.
    // company permissions
    static CrossOrg_Organization_View = Prefixes_1.default.CrossOrgScope + Core.Organization_View; // View Other Orgs
    static CrossOrg_Organization_Edit = Prefixes_1.default.CrossOrgScope + Core.Organization_Edit; // Edit Other Orgs
    // user permissions
    static CrossOrg_User_View = Prefixes_1.default.CrossOrgScope + Core.User_View; // View Users of Other Orgs
    static CrossOrg_User_Add = Prefixes_1.default.CrossOrgScope + Core.User_Add; // Add Users to Other Orgs
    static CrossOrg_User_Edit = Prefixes_1.default.CrossOrgScope + Core.User_Edit; // Edit Users of Other Orgs
    static CrossOrg_User_Status = Prefixes_1.default.CrossOrgScope + Core.User_Status; // Edit Status of Users of Other Orgs
    static CrossOrg_User_Org_Delete = Prefixes_1.default.CrossOrgScope + Core.User_Org_Delete;
    static CrossOrg_User_Delete = Prefixes_1.default.CrossOrgScope + Core.User_Delete; // Delete user
    // role permissions
    static CrossOrg_Role_View = Prefixes_1.default.CrossOrgScope + Core.Role_View; // View Roles of Other Orgs
    static CrossOrg_Role_Add = Prefixes_1.default.CrossOrgScope + Core.Role_Add; // Add Roles to Other Orgs
    static CrossOrg_Role_Edit = Prefixes_1.default.CrossOrgScope + Core.Role_Edit; // Edit Roles of Other Orgs
    static CrossOrg_Role_Delete = Prefixes_1.default.CrossOrgScope + Core.Role_Delete; // Delete Roles from Other Orgs
    // user's risk permissions
    static CrossOrg_User_Risk_View = Prefixes_1.default.CrossOrgScope + Core.User_Risk_View; // View Users' risk of Other Orgs
    static CrossOrg_User_Risk_Edit = Prefixes_1.default.CrossOrgScope + Core.User_Risk_Edit; // Edit Users' risk of Other Orgs
    // Platform Data Import
    static CrossOrg_Platform_Data_Import = Prefixes_1.default.CrossOrgScope + Core.Platform_Data_Import; // Import data into the platform
    static CrossOrg_ClientRegistration_View = Prefixes_1.default.CrossOrgScope + Core.ClientRegistration_View;
    static CrossOrg_ClientRegistration_Add = Prefixes_1.default.CrossOrgScope + Core.ClientRegistration_Add;
    static CrossOrg_ClientRegistration_Edit = Prefixes_1.default.CrossOrgScope + Core.ClientRegistration_Edit;
    static CrossOrg_ClientRegistration_Delete = Prefixes_1.default.CrossOrgScope + Core.ClientRegistration_Delete;
    static CrossOrg_SupportChat_View = Prefixes_1.default.CrossOrgScope + Core.SupportChat_View;
    static CrossOrg_SupportPortal_View = Prefixes_1.default.CrossOrgScope + Core.SupportPortal_View;
    static CrossOrg_FM_Admin = Prefixes_1.default.CrossOrgScope + Core.FulfillmentMarketplace_Admin; // Access all fm resources
    static CrossOrg_FM_View = Prefixes_1.default.CrossOrgScope + Core.FulfillmentMarketplace_View; // View all fm resources
    static CrossOrg_Billing_Admin = Prefixes_1.default.CrossOrgScope + Core.Billing_Admin; // Access all billing resources
    static CrossOrg_Billing_View = Prefixes_1.default.CrossOrgScope + Core.Billing_View; // View all billing resources
    // Connection permissions
    static CrossOrg_Connection_View = Prefixes_1.default.CrossOrgScope + Core.Connection_View;
    static CrossOrg_Connection_Admin = Prefixes_1.default.CrossOrgScope + Core.Connection_Admin;
    // Alert permissions
    static CrossOrg_Essentials_View = Prefixes_1.default.CrossOrgScope + Core.Essentials_View;
    static CrossOrg_Essentials_Admin = Prefixes_1.default.CrossOrgScope + Core.Essentials_Admin;
    static CrossOrg_Analytics_Workspace_Admin = Prefixes_1.default.CrossOrgScope + Core.Analytics_Workspace_Admin;
    static CrossOrg_Analytics_Workspace_Edit = Prefixes_1.default.CrossOrgScope + Core.Analytics_Workspace_Edit;
    static CrossOrg_Analytics_Workspace_View = Prefixes_1.default.CrossOrgScope + Core.Analytics_Workspace_View;
}
exports.default = CorePermissions;
